<mat-form-field class="form-full-width" appearance="outline" [formGroup]="group">
    <i matPrefix *ngIf="field?.leadingIcon" [ngClass]="'mdi mdi-' + field?.leadingIcon" class="input_leading-icon"></i>
    <mat-label>{{ field.label }}</mat-label>
    <input
        matInput
        [formControl]="group.get(field.name)"
        [id]="field.id ? field.id : null"
        [app-restrict-input]="'dateMonth'"
        [app-restrict-input-control]="group.get(field.name)"
        [matDatepicker]="inputDatepicker"
        [matDatepickerFilter]="dataFilter"
        [readonly]="field.disabled"
    />
    <mat-datepicker
        #inputDatepicker
        startView="multi-year"
        (opened)="inputDatepickerOpened()"
        (yearSelected)="chosenYearHandler($event)"
        (monthSelected)="chosenMonthHandler($event, inputDatepicker)"
        panelClass="data-picker-month"
    >
    </mat-datepicker>
    <fui-button
        *ngIf="!field?.hideClearButton && group.get(field.name).value && !field.disabled && !field.is_block"
        (clickEvent)="group.get(field.name).setValue('')"
        matSuffix
        [icon]="'close'"
        [title]="appService.language_dictionary.system_clear"
        [type]="'button-icon'"
        [borderRadius]="'circle'"
        [color]="'neutral'"
        [height]="'mini'"
        [iconSize]="16"
        [disabled]="field.disabled"
    >
    </fui-button>
    <mat-datepicker-toggle matSuffix [for]="inputDatepicker">
        <fui-button
            matDatepickerToggleIcon
            [ngClass]="'z-10'"
            [icon]="'calendar'"
            [type]="'button-icon'"
            [color]="'neutral'"
            [height]="'mini'"
            [borderRadius]="'circle'"
            [disabled]="field.disabled"
            [iconSize]="20"
            [title]="appService.language_dictionary.system_calendar"
        >
        </fui-button>
    </mat-datepicker-toggle>
    <fui-button
        matSuffix
        *ngIf="field?.trailingButton"
        (clickEvent)="outputEvent.emit({ action: field?.trailingButton?.action })"
        [ngClass]="'input_trailing-button'"
        [icon]="field?.trailingButton.icon"
        [title]="field?.trailingButton.title"
        [type]="'button-icon'"
        [borderRadius]="'circle'"
        [color]="'neutral'"
        [height]="'mini'"
        [disabled]="field.disabled"
    >
    </fui-button>
    <mat-hint *ngIf="field.hint" [innerHtml]="field.hint"></mat-hint>
    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
        <mat-error
            *ngIf="group?.get(field.name)?.hasError(validation.name)"
            [innerHTML]="
                validation.name === 'serverError' ? group?.get(field.name)?.errors?.serverError : validation.message
            "
        >
        </mat-error>
    </ng-container>
    <mat-error *ngIf="group.get(field.name).hasError('inputMaskError')">
        {{ group.get(field.name).errors?.inputMaskError }}
    </mat-error>
    <mat-error *ngIf="group.get(field.name).hasError('matDatepickerFilter')">
        {{ appService.language_dictionary.enter_the_correct_period }}
    </mat-error>
</mat-form-field>
